<!-- Shared autocomplete for fields -->
<mat-autocomplete test-id="field-autocomplete" #autoField="matAutocomplete" panelWidth="auto">
  <mat-option *ngFor="let field of fieldSuggestions$ | async" [value]="field.name">
    {{ field.name }}
  </mat-option>
</mat-autocomplete>

<!-- Shared autocomplete for values -->
<mat-autocomplete test-id="display-autocomplete" #autoValue="matAutocomplete" panelWidth="auto" >
  <mat-option *ngFor="let suggestion of valueSuggestions$ | async" [value]="suggestion.value" [matTooltip]="suggestion.value" matTooltipClass="tooltip-stretch">
    {{ suggestion.display }}
  </mat-option>
</mat-autocomplete>

<ng-template #rulesList>
  <mat-list role="list">
    <mat-list-item *ngFor="let form of rules.controls; index as ruleIndex;" [formGroup]="$any(form)" role="listitem" class="compact">
      <!-- Field -->
      <mat-form-field test-id="field-input" appearance="outline" class="field-input solid-background">
        <input #field type="text" matInput formControlName="field"
          [placeholder]="'common.labels.field' | translate"
          [matAutocomplete]="autoField"
          (focus)="bindFieldAutocomplete($any(form))">
      </mat-form-field>

      <mat-form-field
        *ngIf="getOperatorOptions($any(form)).length > 1; else staticOperator"
        test-id="operator-input"
        appearance="outline"
        class="operator-input solid-background">
        <mat-select #operator formControlName="operator" [placeholder]="'common.labels.operator' | translate">
          <mat-option *ngFor="let option of getOperatorOptions($any(form))" [value]="option.value">{{ option.label || option.value }}</mat-option>
        </mat-select>
      </mat-form-field>

      <ng-template #staticOperator>
        <span class="static-operator">{{ getOperatorOptions($any(form))[0].label }}</span>
      </ng-template>

      <!-- Value -->
      <div [ngSwitch]="getValueInterface($any(form))" class="chips-wrapper">
        <!-- Chips -->
        <mat-form-field *ngSwitchCase="'chips'" class="chip-field">
          <fw-chip-input formControlName="chips" test-id="rule-chips" [attr.aria-label]="'fwRulesCreator.chipValueAriaLabel' | translate"
            [disableDrag]="true"
            [suggestions]="valueSuggestions$ | async"
            (focus)="bindSuggestionAutocomplete($any(form))"
            (inputChange)="suggestionInput$.next($event)"
            [allowDuplicates]="true">
          </fw-chip-input>
        </mat-form-field>

        <!-- Number -->
        <mat-form-field *ngSwitchCase="'number'" test-id="number-input" appearance="outline" class="solid-background">
          <input type="number" matInput formControlName="number" autocomplete="off">
        </mat-form-field>

        <!-- Boolean -->
        <mat-form-field *ngSwitchCase="'boolean'" test-id="boolean-select" appearance="outline" class="solid-background">
          <mat-select formControlName="boolean">
            <mat-option test-id="boolean-true" [value]="true">{{ 'common.labels.true' | translate }}</mat-option>
            <mat-option test-id="boolean-false" [value]="false">{{ 'common.labels.false' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Date -->
        <ng-container *ngSwitchCase="'date'" formGroupName="date">
          <mat-form-field test-id="date-input" appearance="outline" class="date-field flex-field solid-background">
            <input formControlName="timestampDate" matInput [matDatepicker]="datepicker" [placeholder]="'common.actions.inputDate' | translate" autocomplete="off">
            <mat-datepicker-toggle [for]="datepicker" class="xs">
              <mat-icon matDatepickerToggleIcon class="xs">event</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #datepicker></mat-datepicker>
            <fw-time-field formControlName="timestampTime"></fw-time-field>
          </mat-form-field>
        </ng-container>

        <!-- Input -->
        <mat-form-field *ngSwitchDefault test-id="value-autocomplete" appearance="outline" class="solid-background">
          <input type="string" matInput formControlName="text" [placeholder]="'common.labels.value' | translate"
            [matAutocomplete]="autoValue" (focus)="bindSuggestionAutocomplete($any(form))">
        </mat-form-field>
      </div>

      <!-- Regex -->
      <mat-checkbox *ngIf="form.get('regex').enabled" test-id="regex-checkbox" formControlName="regex">
        {{ 'common.labels.regex' | translate }}
      </mat-checkbox>

      <div class="rule-actions">
        <!-- Actions -->
        <button type="button" test-id="remove-button" class="xs" mat-icon-button color="error" (click)="removeRule(ruleIndex)" [disabled]="rules.disabled"><mat-icon>remove_circle_outline</mat-icon></button>
        <button type="button" test-id="add-button" class="xs" mat-icon-button color="primary" (click)="addRule(ruleIndex)" [disabled]="rules.disabled"><mat-icon>add_circle_outline</mat-icon></button>
      </div>
    </mat-list-item>
  </mat-list>
</ng-template>

<mat-card appearance="outlined" *ngIf="card" class="rule-card">
  <mat-card-title [matTooltip]="tooltip">
    <ng-container *ngTemplateOutlet="titleContent"></ng-container>
  </mat-card-title>
  <mat-card-content *ngTemplateOutlet="rulesList"></mat-card-content>
</mat-card>

<ng-container *ngIf="!card">
  <ng-container *ngTemplateOutlet="titleContent"></ng-container>
  <ng-container *ngTemplateOutlet="rulesList"></ng-container>
</ng-container>

<ng-template #titleContent>
  <!-- Only one ng-content allowed in the component template -->
  <ng-content></ng-content>
</ng-template>
